export const purchasereportdata = [
  {
    id: 1,
    img: "assets/img/products/stock-img-01.png",
    productName: "Lenovo 3rd Generation",
    productAmount: "$5000",
    productQty: "500",
    instockQty: "100",
  },
  {
    id: 2,
    img: "assets/img/products/stock-img-06.png",
    productName: "Bold V3.2",
    productAmount: "$1000",
    productQty: "200",
    instockQty: "150",
  },
  {
    id: 3,
    img: "assets/img/products/stock-img-02.png",
    productName: "Nike Jordan",
    productAmount: "$2000",
    productQty: "350",
    instockQty: "200",
  },
  {
    id: 4,
    img: "assets/img/products/stock-img-03.png",
    productName: "Apple Series 5 Watch",
    productAmount: "$500",
    productQty: "120",
    instockQty: "50",
  },
  {
    id: 5,
    img: "assets/img/products/stock-img-04.png",
    productName: "Amazon Echo Dot",
    productAmount: "$100",
    productQty: "400",
    instockQty: "320",
  },
  {
    id: 6,
    img: "assets/img/products/stock-img-05.png",
    productName: "Lobar Handy",
    productAmount: "$1500",
    productQty: "170",
    instockQty: "80",
  },
  {
    id: 7,
    img: "assets/img/products/expire-product-01.png",
    productName: "Red Premium Handy",
    productAmount: "$800",
    productQty: "320",
    instockQty: "180",
  },
  {
    id: 8,
    img: "assets/img/products/expire-product-02.png",
    productName: "Iphone 14 Pro",
    productAmount: "$1200",
    productQty: "270",
    instockQty: "120",
  },
  {
    id: 9,
    img: "assets/img/products/expire-product-03.png",
    productName: "Black Slim 200",
    productAmount: "$600",
    productQty: "180",
    instockQty: "70",
  },
  {
    id: 10,
    img: "assets/img/products/expire-product-04.png",
    productName: "Woodcraft Sandal",
    productAmount: "$300",
    productQty: "450",
    instockQty: "300",
  },
];
